<script setup lang="ts">
import giftBoxPreview from '@/assets/components/registerComponent/gift_box-preview.webp'
import giftBoxImg from '@/assets/components/registerComponent/gift_box.webp'
import { mustBeValueValidator } from '@/compositions/validators'

const { t } = useI18n()
</script>

<template>
  <goat-form-field-check-box
    api-field-name="acceptTerms"
    :label="false"
    class="text-lg font-light ml-0.5 goat-large"
    required
    :rules="[{ validator: mustBeValueValidator(true), trigger: 'change', message: t('common.required') }]"
  >
    <template #label>
      {{ t('acceptTermsCheckBoxes.iAccept') }} <a
        href="https://gamesture.com/terms-of-service"
        class="inline underline underline-offset-4 decoration-1 hover:decoration-2 whitespace-nowrap"
        rel="nofollow"
        target="_blank"
      >
        {{ t('acceptTermsCheckBoxes.termsLink') }}
      </a>,
      <a
        href="https://gamesture.com/privacy-policy"
        class="inline underline underline-offset-4 decoration-1 hover:decoration-2 whitespace-nowrap"
        rel="nofollow"
        target="_blank"
      >
        {{ t('acceptTermsCheckBoxes.privacyLink') }}
      </a>
    </template>
  </goat-form-field-check-box>
  <goat-form-field-check-box
    api-field-name="acceptCommunication"
    :label="false"
    class="text-lg font-light ml-0.5 goat-large"
  >
    <template #label>
      <div class="grid grid-cols-[clamp(40px,26%,120px)_1fr] gap-2">
        <div class="col-span-2 font-semibold">
          {{ t('acceptTermsCheckBoxes.communication.title') }}
        </div>
        <div class="w-full">
          <el-image
            :src="giftBoxImg"
            lazy
            alt="benefit icon"
            class="width-full"
          >
            <template #placeholder>
              <img
                :src="giftBoxPreview"
                alt="benefit icon"
                class="w-full"
              >
            </template>
          </el-image>
        </div>
        <div class="">
          <div class="max-w-60 big:leading-[1.3em]">
            {{ t('acceptTermsCheckBoxes.communication.description') }}
          </div>
        </div>
      </div>
    </template>
  </goat-form-field-check-box>
</template>

<style scoped lang="postcss">

</style>
